import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ItemScope } from 'qflow-form-renderer';
import { FormsClient } from '../../core/remote-clients/remote-client';
import { FormType } from '../../models/form-type.model';

export interface FlowFormScopesResult {
  dataScopes: Record<string, ItemScope>;
  allowAdition?: boolean;
  viewHistory?: boolean;
  required?: boolean;
}

@Injectable({ providedIn: 'root' })
export class FlowFormScopesService {
  constructor(private readonly _formsClient: FormsClient) {}

  async getFlowFormsScope(
    packageId: string,
    type: FormType
  ): Promise<FlowFormScopesResult> {
    const response = await firstValueFrom(
      this._formsClient.getFlowFormsScope(packageId, String(type))
    );
    if (!response?.success || !response.entity) {
      return { dataScopes: {} };
    }

    const wireScopes: Record<string, ItemScope> = (response.entity as any)?.dataScopes ?? {};
    const dataScopes = Object.fromEntries(
      Object.entries(wireScopes).filter(
        ([, scopeValue]) => scopeValue !== undefined && scopeValue !== null
      )
    ) as Record<string, ItemScope>;

    return {
      dataScopes,
      allowAdition: (response.entity as any)?.allowAdition,
      viewHistory: (response.entity as any)?.viewHistory,
      required: (response.entity as any)?.required
    };
  }
}


